export default {
  install (Vue) {
    const params = (new URL(window.parent.location)).searchParams
    const platform = params.get('platform') || ''
    const inNativeView = (/ios|android/i).test(platform.toLowerCase())
    const inWebView = (/com.sph.stiphone|com.buuuk.st/i).test(navigator.userAgent.toLowerCase())
    const inSTApp = inNativeView || inWebView
    let inAppOS = ''

    if (inSTApp) {
      if ((/ios/i).test(platform.toLowerCase()) || (/com.sph.stiphone/i).test(navigator.userAgent.toLowerCase())) {
        inAppOS = 'ios'
      } else if ((/android/i).test(platform.toLowerCase()) || (/com.buuuk.st/i).test(navigator.userAgent.toLowerCase())) {
        inAppOS = 'android'
      }
    }

    Vue.prototype.$inSTApp = inSTApp
    Vue.prototype.$inSTAppWebView = inWebView
    Vue.prototype.$inSTAppNativeView = inNativeView
    Vue.prototype.$inSTAppOS = inAppOS
  }
}
